import prod from './app.config.prod';
import type { AppConfig } from './app.config';

/** Explicit build profile; owner login and Gmail cookies stay on the approved HTTPS origin. */
export const assistantPublicPilotConfig: AppConfig = {
  ...prod,
  ENV: 'assistant-public-pilot',
  API_ENDPOINT: 'https://instinct-pilot.blueticks.co',
  NOTIFIER_ENDPOINT: 'https://instinct-pilot.blueticks.co',
  APP_ENDPOINT: 'https://instinct-pilot.blueticks.co',
  PRICING_PAGE: 'https://instinct-pilot.blueticks.co',
  VZNLYTICS_ENDPOINT: '',
  GTM_ID: '',
  GA_ID: '',
  FB_PIXEL_ID: '',
  TIKTOK_ID: '',
  CLARITY_ID: '',
  CRISP_ID: '',
  AW_ID: '',
  WS_ID: '',
  HJ_ID: 0,
  HJ_SV: 0,
};
export default assistantPublicPilotConfig;
